import { numCommas } from "@/utils/numCommas";
import { memo } from "react";

const BedBathSqft = ({ item }) => {
  const { size, lotSize } = item;
  const size_sqft =
  size && size.includes(",")
  ? size.replace(/[^0-9]/g, "")
  : size?.indexOf(".") !== -1
  ? size?.substring(0, size?.indexOf("."))
  : size || lotSize && lotSize.includes(",")
  ? lotSize?.replace(/[^0-9]/g, "")
  : lotSize?.indexOf(".") !== -1
  ? lotSize?.substring(0, lotSize?.indexOf("."))
  : lotSize;

  // Function to truncate number and add ellipsis
  const truncateNumber = (num) => {
    if (num && num.length > 9) {
      return num.substring(0, 9) + "...";
    }
    return num;
  };


  return (
    <div className="prop_details mb0">
      <span className="list-inline-item list-mr0">
        <a href="#" className="BBS-text">
          {numCommas(item?.bedCount) ? numCommas(item?.bedCount) : numCommas(item?.beds) } Beds
        </a>
      </span>
      <span className="bedbathbar" aria-hidden="true">|</span>
      <span className="list-inline-item list-mr0">
        <a href="#" className="BBS-text">
          {numCommas(item?.bathCount) ? numCommas(item?.bathCount)   : numCommas(item?.baths)} Baths
        </a>
      </span>
      {size_sqft && <span className="bedbathbar" aria-hidden="true">|</span>}
      {size_sqft && (
        <span className="list-inline-item list-mr0">
          <a href="#" className="BBS-text">
            {truncateNumber(numCommas(size_sqft))} ft<sup>2</sup>
          </a>
        </span>
      )}
    </div>
  );
};

export default memo(BedBathSqft);